export default __webpack_public_path__ + "static/media/coingeckoon.77fc8d51.png";